import React, { Fragment, useEffect, useState } from "react";
import FcardContact from "../../components/FcardContact/FcardContact";
import FcardGroup from "../../components/FcardGroup/FcardGroup";
import FcardPageTitle from "../../components/FcardPageTitle/FcardPageTitle";
import { useNavigate, useLocation } from "react-router";
import FBannerSpendResponsive from "../../components/FBannerSpendResponsive/FBannerSpend";
import FcardPaymentMethod from "../../components/FcardPaymentMethod/FcardPaymentMethod";
import { usePideFiado } from "../../hooks/usePideFiado";
import { usePaymentMethodScreen } from "./hooks/usePaymentMethodScreen";
import { useCurrencyFormat } from "../../hooks/useCurrencyFormat";
import { CardOutline, ChevronForwardOutline } from "react-ionicons";
import VectorIcons from "../../components/VectorIcons/VectorIcons";
import FContainer from "../../components/FContainer/FContainer";

const PaymentMethodScreen = ({ param }) => {
  const { formatWithCurrencyISO } = useCurrencyFormat();
  const parameters = useLocation();
  const {
    originCurrency,
    destinationCurrencyId,
    component,
    amount,
    idFiadoFlash,
    exchangeRateId,
  } = parameters.state;
  const { getPaymentMethod } = usePideFiado();

  const { paymentMethod, setPaymentMethod, nextScreen } =
    usePaymentMethodScreen();

  useEffect(() => {
    async function gpaymentMethods() {
      let paymentMethods = await getPaymentMethod(
        originCurrency,
        destinationCurrencyId,
        component
      );
      setPaymentMethod(paymentMethods);
    }

    gpaymentMethods();
  }, []);

  // const route = useNavigate();
  // const { state } = useLocation();

  // const { formatWithCurrencyISO } = useCurrencyFormat();

  // const { getPaymentMethod } = usePideFiado();

  // useEffect(() => {
  //   async function gpaymentMethods() {
  //     let paymentMethods = await getPaymentMethod(
  //       state.originCurrency,
  //       state.destinationCurrencyId,
  //       state.component
  //     );
  //     console.log(paymentMethods);
  //     console.log(state);
  //     setPaymentMethod(paymentMethods);
  //   }
  //
  //   gpaymentMethods();
  // }, []);

  return (
    <>
      <div className="grid place-items-center pb-5">
        <div className="border-0 grid grid-cols-2 sm:w-[500px]">
          <div className="border-0 col-span-2 sm:col-span-1 grid place-items-center">
            <img
              className="w-[100px] h-[100px]"
              src={require("../../components/assets/images/pedir-icon.png")}
            />
          </div>
          <div className="border-0 col-span-2 sm:col-span-1 grid place-items-center">
            <div className="font-medium text-[18px] pt-8 sm:pt-0">
              {formatWithCurrencyISO(amount, originCurrency)}
            </div>
            <div className="font-semibold text-[18px] pt-2">
              {component == "PAYMENT_METHOD" ? (
                <div className="text-center font-regular">
                  ¿Qué forma de pago <br /> prefieres?
                </div>
              ) : null}
              {component == "CASHOUT" ? (
                <div className="text-center font-regular">
                  ¿De qué forma prefieres <br /> retirar?
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
      <FContainer>
        {paymentMethod.map((payment, index) => (
          <div
            className="border-0 w-full grid grid-cols-12 shadow-Box rounded-2xl px-2 py-3 my-2 cursor-pointer"
            onClick={() => {
              nextScreen(
                payment.id,
                amount,
                originCurrency,
                destinationCurrencyId,
                "",
                idFiadoFlash,
                exchangeRateId,
                component
              );
            }}
          >
            <div className="border-0 col-span-1 grid place-items-center">
              <VectorIcons name={payment.iconUrl} height="24px" width="24px" />
            </div>
            <div className="border-0 col-span-10 grid items-center font-regular text-[13px] pl-2">
              {payment.displayName}
            </div>
            <div className="border-0 col-span-1 grid place-items-center">
              <ChevronForwardOutline height="24px" width="24px" />
            </div>
          </div>
        ))}
      </FContainer>
    </>
  );
};

export default PaymentMethodScreen;
